export const COST_COLUMN_KEYS = {
  ADR: 'adr',
  COST: 'cost',
  COST_PERCENT: 'costPercent',
  NET_ADR: 'netAdr',
  NET_REVENUE: 'netRevenue',
  NET_REVENUE_PERCENT: 'netRevenuePercent',
  ROOM_NIGHTS: 'roomNights',
  ROOM_REVENUE: 'roomRevenue',
} as const;
export type CostColumnKey =
  (typeof COST_COLUMN_KEYS)[keyof typeof COST_COLUMN_KEYS];

export const DEFAULT_COLUMN_ORDER: CostColumnKey[] = [
  COST_COLUMN_KEYS.ROOM_NIGHTS,
  COST_COLUMN_KEYS.ADR,
  COST_COLUMN_KEYS.NET_ADR,
  COST_COLUMN_KEYS.ROOM_REVENUE,
  COST_COLUMN_KEYS.NET_REVENUE,
  COST_COLUMN_KEYS.NET_REVENUE_PERCENT,
  COST_COLUMN_KEYS.COST,
  COST_COLUMN_KEYS.COST_PERCENT,
];

export const DEFAULT_HIDDEN_COLUMNS: CostColumnKey[] = [
  COST_COLUMN_KEYS.ADR,
  COST_COLUMN_KEYS.ROOM_REVENUE,
];
